import type { ReactNode } from "react";
import type { FieldKind } from "../types";

function Ico({ children }: { children: ReactNode }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {children}
    </svg>
  );
}

function Stroke({ d }: { d: string }) {
  return <path d={d} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />;
}

export function IcoPlus() {
  return (
    <Ico>
      <Stroke d="M12 5v14M5 12h14" />
    </Ico>
  );
}
export function IcoSave() {
  return (
    <Ico>
      <Stroke d="M5 5h11l3 3v11H5V5Z" />
      <Stroke d="M8 5v5h7V5M8 19v-6h8v6" />
    </Ico>
  );
}
export function IcoSend() {
  return (
    <Ico>
      <Stroke d="M4 12 20 5l-6 14-2.2-5.8L4 12Z" />
    </Ico>
  );
}
export function IcoClose() {
  return (
    <Ico>
      <Stroke d="M6 6l12 12M18 6 6 18" />
    </Ico>
  );
}
export function IcoTrash() {
  return (
    <Ico>
      <Stroke d="M5 7h14M10 7V5h4v2m-6 3v8m4-8v8M7 7l.8 12.2A1.5 1.5 0 0 0 9.3 21h5.4a1.5 1.5 0 0 0 1.5-1.8L17 7" />
    </Ico>
  );
}
export function IcoFolder() {
  return (
    <Ico>
      <Stroke d="M4 8V6.5A1.5 1.5 0 0 1 5.5 5H10l2 2h6.5A1.5 1.5 0 0 1 20 8.5V18a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18V8Z" />
    </Ico>
  );
}
export function IcoUpload() {
  return (
    <Ico>
      <Stroke d="M12 16V7m0 0-3.2 3.2M12 7l3.2 3.2M5 18.5h14" />
    </Ico>
  );
}
export function IcoCopy() {
  return (
    <Ico>
      <rect x="8" y="8" width="11" height="11" rx="1.6" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M6 15V6.6A1.6 1.6 0 0 1 7.6 5H16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </Ico>
  );
}
export function IcoLink() {
  return (
    <Ico>
      <Stroke d="M10 13.5a4 4 0 0 0 5.7.4l2.4-2.4a4 4 0 0 0-5.7-5.7l-1.4 1.4" />
      <Stroke d="M14 10.5a4 4 0 0 0-5.7-.4l-2.4 2.4a4 4 0 0 0 5.7 5.7l1.4-1.4" />
    </Ico>
  );
}
export function IcoShield() {
  return (
    <Ico>
      <Stroke d="M12 3l7 3v6c0 5-3.2 8.2-7 9-3.8-.8-7-4-7-9V6l7-3Z" />
      <Stroke d="m8.4 12 2.5 2.5 4.7-5" />
    </Ico>
  );
}
export function IcoEye() {
  return (
    <Ico>
      <Stroke d="M3 12s3.4-6 9-6 9 6 9 6-3.4 6-9 6-9-6-9-6Z" />
      <circle cx="12" cy="12" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </Ico>
  );
}
export function IcoArchive() {
  return (
    <Ico>
      <Stroke d="M4 7h16v3H4V7Zm2 3v8.2A1.3 1.3 0 0 0 7.3 19.5h9.4a1.3 1.3 0 0 0 1.3-1.3V10M10 14h4" />
    </Ico>
  );
}
export function IcoChevron() {
  return (
    <Ico>
      <Stroke d="M7 9.5 12 14.5 17 9.5" />
    </Ico>
  );
}
export function IcoChevronLeft() {
  return (
    <Ico>
      <Stroke d="M14.5 7 9.5 12l5 5" />
    </Ico>
  );
}
export function IcoChevronRight() {
  return (
    <Ico>
      <Stroke d="M9.5 7 14.5 12l-5 5" />
    </Ico>
  );
}
export function IcoPen() {
  return (
    <Ico>
      <Stroke d="M15.2 5.2a1.7 1.7 0 0 1 2.4 0l1.2 1.2a1.7 1.7 0 0 1 0 2.4L9.4 18.2 5 19l.8-4.4Z" />
    </Ico>
  );
}
export function IcoDownload() {
  return (
    <Ico>
      <Stroke d="M12 5v10m0 0-3.2-3.2M12 15l3.2-3.2M5 19h14" />
    </Ico>
  );
}
export function IcoPrint() {
  return (
    <Ico>
      <Stroke d="M7 9V5h10v4M7 15H5.6A1.6 1.6 0 0 1 4 13.4v-3A1.6 1.6 0 0 1 5.6 8.8h12.8A1.6 1.6 0 0 1 20 10.4v3a1.6 1.6 0 0 1-1.6 1.6H17" />
      <Stroke d="M7 13h10v7H7v-7Z" />
    </Ico>
  );
}
export function IcoScale() {
  return (
    <Ico>
      <Stroke d="M12 4.5v13.5M8 20h8M5 8h14" />
      <Stroke d="M5 8 3.2 13.2A3.2 3.2 0 0 0 6.2 17 3.2 3.2 0 0 0 9 13.2L7.2 8M19 8l-1.8 5.2A3.2 3.2 0 0 1 14.2 17 3.2 3.2 0 0 1 17.8 13.2L16.8 8" />
    </Ico>
  );
}

export function FieldGlyph({ kind }: { kind: FieldKind }) {
  if (kind === "text") {
    return (
      <Ico>
        <Stroke d="M6 7h12M12 7v10M8.5 17h7" />
      </Ico>
    );
  }
  if (kind === "paraphe" || kind === "name") {
    return (
      <Ico>
        <Stroke d="M5 16.5c2-6 4.2-9 5.6-9 1.8 0 1.4 7 3.4 7s2.2-7 4.2-7c1.4 0 2.6 2.2 3.8 9" />
      </Ico>
    );
  }
  if (kind === "date") {
    return (
      <Ico>
        <Stroke d="M6 6.5h12v13H6v-13ZM8 4.5v3M16 4.5v3M6 10h12" />
      </Ico>
    );
  }
  if (kind === "number") {
    return (
      <Ico>
        <Stroke d="M9 6v12M15 6v12M6 10h12M6 14h12" />
      </Ico>
    );
  }
  if (kind === "check") {
    return (
      <Ico>
        <Stroke d="M6 6h12v12H6V6Z" />
        <Stroke d="M8.5 12.2 11 15l4.8-5.4" />
      </Ico>
    );
  }
  if (kind === "radio") {
    return (
      <Ico>
        <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="2.6" fill="currentColor" />
      </Ico>
    );
  }
  if (kind === "select") {
    return (
      <Ico>
        <Stroke d="M5 6.5h14v11H5v-11Z" />
        <Stroke d="M8 11h5.5M15.2 9.6 17.4 12l-2.2 2.4" />
      </Ico>
    );
  }
  if (kind === "stamp") {
    return (
      <Ico>
        <Stroke d="M12 4.5 16 8l-4 3.2L8 8l4-3.5Z" />
        <Stroke d="M7 14.5h10v5H7v-5ZM9 11.2V14.5m6-3.3V14.5" />
      </Ico>
    );
  }
  if (kind === "phone") {
    return (
      <Ico>
        <Stroke d="M8 4.8h3.2l1 3.2-2 1.4a11 11 0 0 0 4.4 4.4l1.4-2 3.2 1V16a2 2 0 0 1-2.2 2 15 15 0 0 1-13-13A2 2 0 0 1 8 4.8Z" />
      </Ico>
    );
  }
  return (
    <Ico>
      <Stroke d="M4 16.5c3.2-7 5.5-10 7.2-10 2.2 0 1.6 8 4.2 8 1.8 0 2.4-6 4.6-6 1.2 0 2.4 2 4 8" />
    </Ico>
  );
}
